import React from 'react';
import { Box, Container, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import BrandLogo from '../Brand/BrandLogo';

const LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Product', to: '/product' },
  { label: 'Support', to: '/support' },
  { label: 'Partner with us', to: '/partner' },
  { label: 'Sign in', to: '/login' },
];

/** Shared footer for the public pages. */
const PublicFooter = () => (
  <Box component="footer" sx={{ borderTop: 1, borderColor: 'divider', bgcolor: 'background.paper', py: 4, mt: 'auto' }}>
    <Container maxWidth="lg">
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={3} justifyContent="space-between" alignItems={{ xs: 'flex-start', md: 'center' }}>
        <BrandLogo height={28} />
        <Stack component="nav" direction="row" spacing={3} flexWrap="wrap" useFlexGap>
          {LINKS.map((l) => (
            <Link key={l.to} component={RouterLink} to={l.to} color="text.secondary" underline="hover" variant="body2">{l.label}</Link>
          ))}
        </Stack>
        <Stack spacing={0.5}>
          <Typography variant="body2" color="text.secondary">
            Support: <Link href="mailto:support@excubia.io" underline="hover">support@excubia.io</Link>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Contact: <Link href="mailto:contact@excubia.io" underline="hover">contact@excubia.io</Link>
          </Typography>
        </Stack>
      </Stack>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 3 }}>
        © Excubia
      </Typography>
    </Container>
  </Box>
);

export default PublicFooter;
